import React from "react";
import { initials } from "@/lib/format";

export default function Avatar({ src, name, size = 44, className = "" }) {
  const [err, setErr] = React.useState(false);
  const showImg = src && !err;
  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-accent text-brand-700 ${className}`}
      style={{ width: size, height: size }}
    >
      {showImg ? (
        <img
          src={src}
          alt={name || ""}
          onError={() => setErr(true)}
          className="h-full w-full object-cover"
        />
      ) : (
        <span style={{ fontSize: size * 0.4 }} className="font-bold">
          {initials(name)}
        </span>
      )}
    </div>
  );
}
